module.exports = __webpack_public_path__ + "bbc0ad2e4976cf09b2cd9ce6ca737371.svg";